<template>
    <search-group title="生活费用管理" @search="findData" @clear="clearValue" :span="8">
        <Row>
            <Col span="3" class="zr-label">项目</Col>
            <Col span="15">
                 <Select v-model="projectFid">
                    <Option value="">请选择</Option>
                    <Option value="100" v-for="item in list.projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">
// import SearchGroup from 'components/SearchGroup/index';
import { getInitData } from 'api/waterAndElectricity';
export default {
    components: {
        // SearchGroup
    },
    data () {
        return {
            projectFid:'',
            list:{
                projectList:[]
            }
        }
    },
    created () {
        this.init();
    },
    methods: {
        findData() {
            this.$emit('project', this.projectFid);
        },
        clearValue() {
            this.projectFid = '';
        },
        init() {
            getInitData().then(res => {
                this.list.projectList = res.data;
            })
        }

    }
}
</script>
